import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { StatusCode } from "api/protocols";
import { showError, showSuccess } from "redux/actions/ui";
import { useAppDispatch } from "hooks/redux";
import Page from "components/page/Page";
import Input from "components/form/input/Input";
import Card from "components/card/Card";
import { PostFoodOrderingCategories } from "api/rpc/2024-04/facilityAdmin/facility/foodOrdering";

interface IFoodOrderingCategoryState {
  title: string;
}

export default function NewFoodOrderingCategory() {
  const history = useHistory();
  const { t } = useTranslation();

  const [foodOrderingState, setFoodOrderingState] = useState<IFoodOrderingCategoryState>({
    title: "",
  });

  const dispatch = useAppDispatch();

  function handleInputChange(e: any) {
    const id = e.target.id;
    const value = e.target.value;

    setFoodOrderingState((prev) => ({ ...prev, [id]: value }));
  }

  async function handleCreateCategory() {
    const params = {
      title: foodOrderingState.title,
    };

    const createCategoryRes = await PostFoodOrderingCategories(params, true);

    if (createCategoryRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error creating category")));
      return;
    }

    dispatch(showSuccess(t("Successfully created category")));
    history.push("/admin/food-ordering/overview");
  }

  return (
    <Page
      title={t("New Food Ordering Category")}
      primaryAction={{
        content: t("Save"),
        action: handleCreateCategory,
        disabled: foodOrderingState.title === "",
      }}
      breadcrumbs={[
        {
          prefix: true,
          label: t("Back to overview"),
          url: "/admin/food-ordering/overview",
        },
      ]}
    >
      <Card>
        <Card.Section>
          <div>
            <Input
              placeholder={t("Category Title...")}
              id="title"
              value={foodOrderingState.title}
              onChange={handleInputChange}
              label={t("Category Title")}
            />
          </div>
        </Card.Section>
      </Card>
    </Page>
  );
}
